var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    this.data.cover !== null
      ? _c("div", { staticClass: "shadow" }, [
          _c("img", {
            staticClass: "img-fluid",
            staticStyle: { "object-fit": "cover" },
            attrs: { src: this.data.cover.url },
          }),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "card-content pt-1 pb-1" }, [
      _c("div", { staticClass: "col-md-12" }, [
        _c("div", { staticClass: "d-flex" }, [
          _c("div", { staticClass: "w-100" }, [
            this.data.cover === null
              ? _c("div", [
                  this.data.resource_file_type === "doc"
                    ? _c(
                        "div",
                        {
                          staticClass: "d-inline-block mr-05 mb-05 float-left",
                        },
                        [
                          _c("img", {
                            attrs: {
                              src: "/images/icons/doc.png",
                              width: "25px",
                            },
                          }),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  this.data.resource_file_type === "docx"
                    ? _c(
                        "div",
                        {
                          staticClass: "d-inline-block mr-05 mb-05 float-left",
                        },
                        [
                          _c("img", {
                            attrs: {
                              src: "/images/icons/doc.png",
                              width: "25px",
                            },
                          }),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  this.data.resource_file_type === "txt"
                    ? _c(
                        "div",
                        {
                          staticClass: "d-inline-block mr-05 mb-05 float-left",
                        },
                        [
                          _c("img", {
                            attrs: {
                              src: "/images/icons/doc.png",
                              width: "25px",
                            },
                          }),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  this.data.resource_file_type === "pdf"
                    ? _c(
                        "div",
                        {
                          staticClass: "d-inline-block mr-05 mb-05 float-left",
                        },
                        [
                          _c("img", {
                            attrs: {
                              src: "/images/icons/pdf.png",
                              width: "25px",
                            },
                          }),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  this.data.resource_file_type === "xls"
                    ? _c(
                        "div",
                        {
                          staticClass: "d-inline-block mr-05 mb-05 float-left",
                        },
                        [
                          _c("img", {
                            attrs: {
                              src: "/images/icons/xls.png",
                              width: "25px",
                            },
                          }),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  this.data.resource_file_type === "xlsx"
                    ? _c(
                        "div",
                        {
                          staticClass: "d-inline-block mr-05 mb-05 float-left",
                        },
                        [
                          _c("img", {
                            attrs: {
                              src: "/images/icons/xls.png",
                              width: "25px",
                            },
                          }),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  this.data.resource_file_type === "ppt"
                    ? _c(
                        "div",
                        {
                          staticClass: "d-inline-block mr-05 mb-05 float-left",
                        },
                        [
                          _c("img", {
                            attrs: {
                              src: "/images/icons/ppt.png",
                              width: "25px",
                            },
                          }),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  this.data.resource_file_type === "pptx"
                    ? _c(
                        "div",
                        {
                          staticClass: "d-inline-block mr-05 mb-05 float-left",
                        },
                        [
                          _c("img", {
                            attrs: {
                              src: "/images/icons/ppt.png",
                              width: "25px",
                            },
                          }),
                        ]
                      )
                    : _vm._e(),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("span", { staticClass: "h3" }, [
              _c(
                "a",
                {
                  staticStyle: { color: "inherit" },
                  attrs: { href: "/" + this.data.type + "/" + this.data.slug },
                },
                [_vm._v(_vm._s(this.data.title))]
              ),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "mb-05" }, [
          _c(
            "div",
            {
              directives: [{ name: "linkified", rawName: "v-linkified" }],
              staticClass: "breakAll pt-1",
            },
            [
              _c("span", {
                staticClass: "breakAll image-resize",
                domProps: { innerHTML: _vm._s(this.data.resource_description) },
              }),
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "text-right" }, [
            _c(
              "a",
              {
                staticClass: "font-small-3",
                attrs: { href: "/" + this.data.type + "/" + this.data.slug },
              },
              [
                _vm._v(_vm._s(_vm.__("globals.read_more"))),
                _c("i", { staticClass: "feather icon-chevron-right" }),
              ]
            ),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "pl-05 pr-05" }, [
        _c(
          "span",
          {
            attrs: { "data-toggle": "modal", "data-target": "#registerModal" },
          },
          [
            this.data.external_url !== null
              ? _c("div", [
                  _c(
                    "a",
                    {
                      staticClass:
                        "download-button btn btn-primary waves-effect waves-light form-control",
                    },
                    [
                      _c("i", { staticClass: "fa fa-link" }),
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.__(
                              "resource.form.buttons.access_external_resource"
                            )
                          ) +
                          "\n                    "
                      ),
                    ]
                  ),
                ])
              : _c("div", [
                  _c(
                    "a",
                    {
                      staticClass:
                        "download-button btn btn-primary waves-effect waves-light form-control",
                    },
                    [
                      _c("i", { staticClass: "fa fa-download" }),
                      _vm._v(
                        " " +
                          _vm._s(_vm.__("resource.form.buttons.download")) +
                          "\n                    "
                      ),
                    ]
                  ),
                ]),
          ]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }